import { Component, OnInit } from '@angular/core';
import { BrowserCompatibilityService } from 'src/app/core/services/browser-compatibility.service';

@Component({
  selector: 'app-browser-check',
  templateUrl: './browser-check.component.html',
  styleUrls: ['./browser-check.component.scss']
})
export class BrowserCheckComponent implements OnInit {
  isSupported = false; // Default to false for security
  browserResult!: any;

  constructor(private browserService: BrowserCompatibilityService) {}

  ngOnInit() {
    this.performBrowserCheck();
  }

  private performBrowserCheck() {
    this.browserResult = this.browserService.checkBrowserSupport();
    this.isSupported = this.browserResult.isSupported;
    
    // Block the entire app by preventing scrolling and interaction
    if (!this.isSupported) {
      document.body.style.overflow = 'hidden';
      document.body.style.userSelect = 'none';
      document.body.style.pointerEvents = 'none';
      
      // Re-enable pointer events only for the warning modal
      setTimeout(() => {
        const warningElement = document.querySelector('.browser-warning') as HTMLElement;
        if (warningElement) {
          warningElement.style.pointerEvents = 'auto';
        }
      });
    } else {
      // Restore normal functionality if supported
      document.body.style.overflow = '';
      document.body.style.userSelect = '';
      document.body.style.pointerEvents = '';
    }
  }

  checkAgain() {
    // Force a fresh check
    window.location.reload();
  }

  ngOnDestroy() {
    // Cleanup styles when component is destroyed
    document.body.style.overflow = '';
    document.body.style.userSelect = '';
    document.body.style.pointerEvents = '';
  }
}
